import Swiper from "swiper";

export default function () {
    const slidersList = document.querySelectorAll('.normal-slider');

    slidersList.forEach((slider) => {

       let params = {
           //loop: true,
           spaceBetween: 30,
           allowTouchMove: true,
           navigation: {
               nextEl: '.ns-next',
               prevEl: '.ns-prev',
           },
           breakpoints: {

           }
       };

       if(slider.hasAttribute('data-autoplay')) {
           params.autoplay = {
               delay: slider.getAttribute('data-autoplay'),
               disableOnInteraction: false
           };
       }

        if(slider.hasAttribute('data-autoheight')) {
            params.autoHeight = true;
        }

        if(slider.hasAttribute('data-perview')) {
            params.slidesPerView = slider.getAttribute('data-perview');
        }

        if(slider.hasAttribute('data-perview768') || slider.hasAttribute('data-perview992')) {

            if(slider.hasAttribute('data-perview768') && slider.hasAttribute('data-perview992')) {

                params.breakpoints['0'] = {
                    slidesPerView : slider.getAttribute('data-perview768')
                };

                params.breakpoints['769'] = {
                    slidesPerView : slider.getAttribute('data-perview992')
                };

                params.breakpoints['993'] = {
                    slidesPerView : slider.getAttribute('data-perview')
                };

            } else {

                if(slider.hasAttribute('data-perview768')) {
                    params.breakpoints['0'] = {
                        slidesPerView : slider.getAttribute('data-perview768')
                    };

                    params.breakpoints['769'] = {
                        slidesPerView : slider.getAttribute('data-perview')
                    };

                }

                if(slider.hasAttribute('data-perview992')) {
                    params.breakpoints['0'] = {
                        slidesPerView : slider.getAttribute('data-perview992')
                    };

                    params.breakpoints['993'] = {
                        slidesPerView : slider.getAttribute('data-perview')
                    };
                }
            }

        }

        new Swiper('#' + slider.getAttribute('id') + ' .swiper-container', params);

    });
};